import axiosInstanceNode from "@/api/axiosInstanceNode";

// Fetch organizations list for super admin
export const fetchSuperAdminOrganizationsList = async () => {
  try {
    const response = await axiosInstanceNode.get("/auth/organizations");
    return response?.data?.organizations;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch organizations list. Please try again.");
  }
};

/** Superadmin: users in a specific organization */
export const fetchSuperAdminOrgUsers = async (orgId, { limit = 100, offset = 0 } = {}) => {
  try {
    const response = await axiosInstanceNode.get(
      `/auth/organizations/${orgId}/users`,
      { params: { limit, offset } },
    );
    return response?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to fetch organization members.",
    );
  }
};

/** Superadmin: voice calling status, wallet and limits for every organization */
export const fetchVoiceOrganizations = () =>
  axiosInstanceNode.get("/voice/admin/organizations").then((res) => res.data?.data || []);

export const creditVoiceWallet = (orgId, { amountUsd, note }) =>
  axiosInstanceNode
    .post(`/voice/admin/organizations/${orgId}/credit`, { amount_usd: amountUsd, note })
    .then((res) => res.data);

export const suspendVoiceOrganization = (orgId, reason) =>
  axiosInstanceNode
    .post(`/voice/admin/organizations/${orgId}/suspend`, { reason })
    .then((res) => res.data);

export const resumeVoiceOrganization = (orgId) =>
  axiosInstanceNode.post(`/voice/admin/organizations/${orgId}/resume`).then((res) => res.data);

export const updateVoiceCaps = (orgId, caps) =>
  axiosInstanceNode.patch(`/voice/admin/organizations/${orgId}/caps`, caps).then((res) => res.data);

export const logVoiceComplaint = (orgId, { phone, note }) =>
  axiosInstanceNode
    .post(`/voice/admin/organizations/${orgId}/complaints`, { phone, note })
    .then((res) => res.data);

export const fetchVoiceApprovals = () =>
  axiosInstanceNode.get("/voice/admin/approvals").then((res) => res.data?.data || []);

export const approveVoiceOrganization = (orgId) =>
  axiosInstanceNode.post(`/voice/admin/organizations/${orgId}/approve`).then((res) => res.data);

export const rejectVoiceOrganization = (orgId, note) =>
  axiosInstanceNode.post(`/voice/admin/organizations/${orgId}/reject`, { note }).then((res) => res.data);
